import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

export interface IShoppingListTypesAddProductRequest {
  productId: number;
  unitId: number;
  quantity: number;
  type: 'FAVORITES';
}

type IResponse = ICommandResponseSuccess;

const postShoppingListTypesAddProduct = (data: IShoppingListTypesAddProductRequest): Promise<IResponse> =>
  axios.post('/shopping-lists/types/add-product', data);

export const usePostShoppingListTypesAddProduct = (
  options?: UseMutationOptions<IResponse, IError, IShoppingListTypesAddProductRequest>
) => useMutation((data: IShoppingListTypesAddProductRequest) => postShoppingListTypesAddProduct(data), options);
